import {useIsBskyTeam} from '#/lib/hooks/useIsBskyTeam'
import {useIsGrapeVyneTeam} from '#/lib/hooks/useIsGrapeVyneTeam'

/**
 * Videos nav is limited to Bluesky team (GrowthBook) or GrapeVyne team (PostHog).
 */
export function useCanAccessVideos() {
  const isBskyTeam = useIsBskyTeam()
  const isGrapeVyneTeam = useIsGrapeVyneTeam()
  return isBskyTeam || isGrapeVyneTeam
}
